import React from "react";
import {Button} from "@mui/material";
import {styled} from "@mui/system";


const StyledButton = styled(Button)(() => ({
    backgroundColor: '#39ad84',
    fontWeight: '700',
    fontSize: '14px',
    color: '#fff',
    textTransform: 'none',
    position: 'absolute',
    padding: '6px 12px',
    border: 'none',
    borderRadius: '2px',
    height: '43px',
    left: '0px',
    bottom: '0px',
    transition: 'all .2s',
    [`& svg`]: {
        marginRight: '5px'
    },
    '&:hover': {
        backgroundColor: '#39ad84',
        height: '48px',
        paddingBottom: '11px'
    }
}));

const TutorialButton = (props) => {
    return (
        <StyledButton
            onClick={props.displayTutorialDialog}
            sx={{
                left: props.feedbackBtnVisible ? '250px' : '150px'
            }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                <path d="M0 0h24v24H0z" fill="none"></path>
                <path fill="currentColor"
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"></path>
            </svg>
            Tutorial
        </StyledButton>
    );
}

export default TutorialButton;
